import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { capitalize, noDataFound } from "../../../CommonMethhods/CommonMethods";

function PartnerAnalyticMarketCap(props) {
  const marketCap = props?.marketCap;
  const large = Number(marketCap?.large?.value?.toFixed(2));
  const mid = Number(marketCap?.mid?.value?.toFixed(2));
  const small = Number(marketCap?.small?.value?.toFixed(2));
  

  const RIGHT_ANALYTIC = [large, mid, small];

  const Donut = {
    credits: {
      enabled: false,
    },
    chart: {
      plotBackgroundColor: null,
      plotBorderWidth: 0,
      plotShadow: false,
      height: 320,
      width: 320,
      plotAreaWidth: 700,
      plotAreaHeight: 500,
    },
    title: {
      text: "Market cap",
      align: "center",
      verticalAlign: "middle",
      y: 20, // for title top margin
    },
    tooltip: {
      pointFormat: `{series.name}: <b>{point.percentage:.1f}%</b>`,
    },

    accessibility: {
      point: {
        valueSuffix: "%",
      },
    },
    plotOptions: {
      pie: {
        dataLabels: {
          enabled: false, // to hide labels
          style: {
            fontWeight: "bold",
            color: "white",
          },
        },
      },
    },
    series: [
      {
        name: "Revenue",
        type: "pie",
        size: "100%",
        innerSize: "50%",

        // states: {
        //   hover: {
        //     halo: true

        //   },
        // },

        data: [
          { name: "Large Cap ", y: large },
          { name: "Mid Cap ", y: mid },
          { name: "Small Cap", y: small },
        ],
      },
    ],

    colors: ["#FF86B1", "#61CFF2", "#886cc0"],
  };

  return (
    <div className="market-cap">
      {marketCap && marketCap ? (
        <>
          {/* <div className="transactions__left__chart"> */}
          <HighchartsReact highcharts={Highcharts} options={Donut} />
          {/* <img src={volumeGraph} alt="volume-graph" /> */}
          {/* </div> */}
          <div className="rightAnalytic">
            {RIGHT_ANALYTIC.map((item, i) => {
              let data;
              let alpha;
              if (i == 0) {
                data = "large";
                alpha = "R";
              } else if (i == 1) {
                data = "mid";
                alpha = "M";
              } else {
                data = "small";
                alpha = "S";
              }

              return (
                <>
                  <div className={data} key={i}>
                    <span className={`${alpha}large`}>{`${item} %`}</span>
                    <span className={`${alpha}large2`}>{capitalize(data)}</span>
                  </div>
                </>
              );
            })}
          </div>
        </>
      ) : (
        noDataFound()
      )}
    </div>
  );
}

export default PartnerAnalyticMarketCap;
